var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('div', [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t('Phone No.')))])]), _c('div', {
    staticClass: "flex items-center justify-conter w-full mb-[1rem]"
  }, [_c('div', {
    staticClass: "w-[30%] xl:w-[25%] mr-[1rem]"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone_area_code"
    }
  }, [_c('phone-area-code-select', {
    model: {
      value: _vm.form.phone_area_code,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone_area_code", $$v);
      },
      expression: "form.phone_area_code"
    }
  })], 1)], 1), _c('div', {
    staticClass: "grow"
  }, [_c('el-form-item', {
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    model: {
      value: _vm.form.phone,
      callback: function ($$v) {
        _vm.$set(_vm.form, "phone", $$v);
      },
      expression: "form.phone"
    }
  })], 1)], 1)]), _c('el-form-item', [_c('el-button', {
    staticClass: "green-button",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.submitForm('form');
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('Verify Phone No.')))])], 1)], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };